WiseMetering.Views.FolderManage = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'folder',
    template: 'templates/folders/manage',
    title: () => i18next.t('modal.title.folders.new'),
    width: 470
});
